import { useEditorContext } from "../../Wysiwyg";
import ToolbarItem from "../ToolbarItem";

const alignments = [
  { label: "Balra igazítás", value: "left", hotkey: "Ctrl + Shift + L" },
  { label: "Középre igazítás", value: "center", hotkey: "Ctrl + Shift + E" },
  { label: "Jobbra igazítás", value: "right", hotkey: "Ctrl + Shift + R" },
  {
    label: "Sorkizártra igazítás",
    value: "justify",
    hotkey: "Ctrl + Shift + J",
  },
];

const AlignToolbarGroup = () => {
  const { editor } = useEditorContext();

  return (
    <>
      {alignments.map((align) => (
        <ToolbarItem
          id={`align-${align.value}-toolbar-item`}
          key={align.label}
          tooltip={align.label}
          active={editor.isActive({ textAlign: align.value })}
          hotkey={align.hotkey}
          onToggle={() =>
            editor.chain().focus().setTextAlign(align.value).run()
          }
          icon={
            <i className={`fa fa-align-${align.value}`} aria-hidden="true" />
          }
        />
      ))}
    </>
  );
};

export default AlignToolbarGroup;
